import store from '@/store'
import { useToast } from 'vue-toastification'
import router from '@/router'

const toast = useToast()

export default (to, from, next) => {
  if (store.state.auth.jwtPayload == null){
    store.dispatch('auth/logout');
    return;
  }
  
  if (!store.state.auth.isSuperAdmin && store.state.auth.accessType == null) {
    toast.error("Only Vertex users are allowed to view this page.");
    router.push('/audits');
    return next()
  }

}

